import React, { useId } from "react";

const InlineCheckbox = ({
  label,
  checked,
  onChange,
  value,
  disabled = false,
  style = {},
  ...props
}) => {
  const inputId = useId();

  // Add blue-checkbox class and accentColor style when disabled (like PartMentionsPopup)
  // Use readOnly instead of disabled to allow CSS styling (same as PartMentionsPopup)
  // Match exact styling from PartMentionsPopup: className="blue-checkbox" and style={{ accentColor: "#0D6EFD", cursor: "default", pointerEvents: "none", opacity: 0.5 }}
  const checkboxStyle = disabled
    ? {
        pointerEvents: "auto",
        cursor: "default",
        accentColor: "#0d6efd",
        opacity: checked ? 0.6 : 0.5,
        ...style,
      }
    : {
        pointerEvents: "auto",
        cursor: "pointer",
        ...style,
      };

  // Always add blue-checkbox class when disabled (checked or unchecked) - same as PartMentionsPopup
  const checkboxClassName = disabled ? "blue-checkbox" : undefined;

  return (
    <label
      htmlFor={inputId}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        cursor: disabled ? "not-allowed" : "pointer",
        userSelect: "none",
      }}
    >
      <input
        id={inputId}
        type="checkbox"
        className={checkboxClassName}
        checked={checked}
        onChange={disabled ? undefined : onChange}
        value={value}
        readOnly={disabled}
        style={checkboxStyle}
        {...props}
      />
      {React.isValidElement(label) && typeof label === "object" ? (
        React.cloneElement(label, {
          style: { marginLeft: 0, ...(label.props?.style || {}) },
        })
      ) : (
        <span>{label}</span>
      )}
    </label>
  );
};

export default InlineCheckbox;
